import { ChartOptions } from 'chart.js';
import { SURVEY_TYPES } from './survey-types';

const tooltipTitleCallback = {
    callbacks: {
        title: (): string => {
            return 'Number of participants';
        },
    },
};

/**
 * Takes a string phrase and breaks it into separate phrases
 * no bigger than 'maxwidth', breaks are made at complete words.
 */
function formatLabel(str: string, maxwidth): any {
    const sections = [];
    const words = str.split(' ');
    let temp = '';

    words.forEach(function (item, index) {
        if (temp.length > 0) {
            const concat = temp + ' ' + item;

            if (concat.length > maxwidth) {
                sections.push(temp);
                temp = '';
            } else {
                if (index == words.length - 1) {
                    sections.push(concat);
                    return;
                } else {
                    temp = concat;
                    return;
                }
            }
        }

        if (index == words.length - 1) {
            sections.push(item);
            return;
        }

        if (item.length < maxwidth) {
            temp = item;
        } else {
            sections.push(item);
        }
    });

    return sections;
}

const BAR_CHART_OPTIONS: ChartOptions = {
    layout: {
        padding: {
            top: 30,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: { tooltip: tooltipTitleCallback, legend: { display: false } },
    scales: {
        x: {
            grid: { display: false },
            stacked: false,
            ticks: {
                font: { size: 15, family: 'Tenon', lineHeight: 2 },
                color: '#000000',
            },
        },
        y: {
            stacked: false,
            grid: { display: false },
        },
    },
};

const HORIZONTAL_BAR_CHART_OPTIONS: ChartOptions = {
    layout: {
        padding: {
            right: 100,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: { tooltip: tooltipTitleCallback, legend: { display: false } },
    scales: {
        x: {
            grid: { display: false },
            stacked: false,
        },

        y: {
            stacked: false,
            grid: { display: false },
            ticks: {
                color: '#000000',
                font: {
                    family: 'Tenon',
                    size: 13,
                },
                callback: function (label: number): string {
                    return formatLabel(label.toString(), 65);
                },
            },
        },
    },
};

const PIE_CHART_OPTIONS: ChartOptions = {
    responsive: true,
    layout: {
        padding: {
            top: 30,
            bottom: 30,
        },
    },
    maintainAspectRatio: false,
    plugins: { tooltip: tooltipTitleCallback, legend: { display: false } },
};

const RATING_CHART_OPTIONS: ChartOptions = {
    layout: {
        padding: {
            top: 30,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: { tooltip: tooltipTitleCallback, legend: { display: false } },
    scales: {
        x: {
            grid: { display: false },
            stacked: false,
            ticks: {
                font: { size: 15, family: 'Tenon' },
                color: '#000000',
            },
        },

        y: {
            stacked: false,
            grid: { display: false },
        },
    },
};

export const CHART_OPTIONS = {
    [SURVEY_TYPES.SCALE]: BAR_CHART_OPTIONS,
    [SURVEY_TYPES.MULTIPLE]: HORIZONTAL_BAR_CHART_OPTIONS,
    [SURVEY_TYPES.BOOLEAN]: PIE_CHART_OPTIONS,
    [SURVEY_TYPES.RATING]: RATING_CHART_OPTIONS,
};
